import React from "react";
import { motion } from "framer-motion";
import testimonios from "../../data/testimonios.json";
/**
 * TestimonialsMarquee.jsx
 * React component (JSX) using Framer Motion + TailwindCSS
 * - Muestra testimonios en doble fila con desplazamiento infinito
 * - Fila superior se desplaza hacia la izquierda, fila inferior hacia la derecha
 * - Extensión: .jsx
 *
 * Props:
 * - testimonials: array de objetos { id, name, role, text }
 * - topDuration, bottomDuration: duración en segundos (controlan velocidad)
 */

const Testimonios = testimonios;


function TestimonialCard({ t }) {
  return (
    <article
      role="listitem"
      className="w-72 sm:w-[400px] lg:w-[500px] shadow-[-10px_10px_0px_0px_#0d2334] flex flex-col justify-center bg-gray-200 p-4 rounded-2xl  mr-4 select-none rounded-[15px] gap-5 hover:bg-yellow-200 transition-all duration-300 ease-in-out"
      aria-label={`Testimonio de ${t.nombre}`}
    >
      <p className="text-base md:text-lg text-primario hyphens-none">“{t.testimonio}”</p>
      <div className="mt-auto flex items-center justify-start gap-5">
        <div className="w-12 h-12 md:w-14 md:h-14 border-blue-4 border-2 rounded-full bg-white overflow-hidden">
          <img
            src={t.imagen}
            alt="lo que dicen nuestros estudiantes de Brighton Centro de Inglés"
            className="object-cover object-center w-full h-full"
          />
        </div>
        <div>
          <p className="font-semibold text-sm md:text-base text-primario">{t.nombre}</p>
          <p className="text-sm text-primario">{t.rol}</p>
        </div>
      </div>
    </article>
  );
}

function MarqueeRow({ items, duration = 20, reverse = false, ariaLabel }) {
  // Duplicate items to create seamless loop
  const displayed = [...items, ...items];

  // animate x from 0% to -50% (or 0% to 50%) so duplicated content scrolls seamlessly
  const from = reverse ? "-50%" : "0%";
  const to = reverse ? "0%" : "-50%";

  return (
    <div className="w-full h-full pb-5">
      <motion.div
        className="inline-flex items-start"
        aria-label={ariaLabel}
        animate={{ x: [from, to] }}
        transition={{
          repeat: Infinity,
          repeatType: "loop",
          ease: "linear",
          duration,
        }}
      >
        {displayed.map((t, i) => (
          <div key={`${t.id}-${i}`} className="">
            <TestimonialCard t={t} />
          </div>
        ))}
      </motion.div>
    </div>
  );
}




export default function TestimonialsMarquee({
  testimonials = Testimonios,
  topDuration = 230,
}) {
  return (
    <div
      className={`w-full my-12 md:my-20`}
      aria-label="Testimonios de estudiantes Brighton"
      role="region"
    >
      <div className="w-full space-y-12">
        <h2 className="text-4xl sm:text-5xl lg:text-6xl text-primario font-semibold text-center">
          Lo que dicen nuestros <strong className="text-secundario">estudiantes</strong>
        </h2>

        {/* Fila superior: se mueve hacia la izquierda */}
        <div className="overflow-hidden" >
          <MarqueeRow
            items={testimonials}
            duration={topDuration}
            reverse={false}
            ariaLabel="Fila de testimonios desplazándose a la izquierda"
          />
        </div>

        {/* Fila inferior: se mueve hacia la derecha */}
        {/* <div>
          <MarqueeRow
            items={testimonials}
            duration={bottomDuration}
            reverse={true}
            ariaLabel="Fila de testimonios desplazándose a la derecha"
          />
        </div> */}
      </div>
    </div>
  );
}
